
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/cases/zebra",
      function () {
        return require("private-next-pages/cases/zebra/index.tsx");
      }
    ]);
  